import { useMemo } from 'react';
import { i18n } from '../language';

const useTags = (roomType, tags, notification) => {
  return useMemo(() => {
    if (roomType?.length === 1 && roomType[0] === 2) {
      const tempTags = Array.isArray(tags) ? tags : [];
      return [
        notification ? i18n.t('EHANDOVER_NOTE_WARDIC_ONLY') : { tagDesc: i18n.t('EHANDOVER_NOTE_WARDIC_ONLY') },
        ...tempTags,
      ];
    } else {
      return Array.isArray(tags) ? tags : [];
    }
  }, [roomType, i18n.t('EHANDOVER_NOTE_WARDIC_ONLY'), tags]);
};

export default useTags;
